export default __webpack_public_path__ + "static/media/home_top.dce864e8.jpg";